<template>
  <div class="sign-in-page px30">
    <div
      v-if="!$getState('forgotPasswordForm')"
      class="sign-in-form sign-in-inner"
    >
      <div v-if="$getState('corporation')['is']" class="dynamic-logo">
        <img class="page-logo" :src="$getState('corporation')['dark_logo']" />
      </div>
      <button
        v-if="isCorporation"
        type="button"
        class="signin-back btn-empty-wrapper"
        @click="clickHandler"
      >
        <Close
          icon="back"
          :customeBackButtonColor="$getState('corporation')['button_color']"
        ></Close>
      </button>
      <button
        v-else
        type="button"
        class="signin-back btn-empty-wrapper"
        @click="clickHandler"
      >
        <Close icon="back"></Close>
      </button>

      <h2
        class="page-title text-center color-text text-28 text-text pt-7 tracking-tight"
      >
        <span class="text-primary">{{ $t("Welcome") }}</span>
        <span class="text-content">{{ $t("Back") }}</span>
      </h2>
      <p class="page-subtitle text-12 text-light">
        {{ $t("Sign in to continue") }}
      </p>
      <SocialLogin />
      <div class="sign-up-or relative">
        <span class="relative color-text text-28 tracking-tight">{{
          $t("Or")
        }}</span>
      </div>
      <div class="form-items form-with-icons" :class="btnClass">
        <FormulateForm #default="{ hasErrors }">
          <div
            class="form-item-row relative"
            :class="{ 'sign-in-error': signError }"
          >
            <FormulateInput
              v-model="values.login"
              type="email"
              name="login"
              label="."
              :placeholder="$t('Email')"
              validation="required|email"
              @input="signError = false"
              @keypress.enter.native.prevent="formHandler"
            />
          </div>
          <div
            class="form-item-row form-item-row_pass relative"
            :class="{ 'sign-in-error': signError }"
          >
            <FormulateInput
              v-model="values.password"
              type="toggablePassword"
              name="password"
              label="."
              :placeholder="$t('Password')"
              validation="required"
              @input="signError = false"
              @keypress.enter.native.prevent="formHandler"
            />
            <div class="reset-password flex">
              <span class="mr-1" v-show="signError">{{
                $t("Incorrect password or email")
              }}</span>
            </div>
          </div>
          <div class="remember-me form-item-row form-item-row_remember">
            <FormulateInput
              v-model="values.rememberMe"
              type="checkbox"
              id="rememberMe"
              :label="$t('Remember me')"
            />
          </div>
          <div class="form-item-row flex items-center">
            <div class="form-item-row__btn pr-4">
              <FormulateButton
                :form-handler="formHandler"
                :has-errors="hasErrors"
                :title="$t('Sign In')"
              />
            </div>
            <div class="form-item-row__forgot flex-grow">
              <button class="btn-link ml-1" @click="resetPassword">
                {{ $t("Forgot your password") }}
              </button>
            </div>
          </div>
        </FormulateForm>
      </div>
    </div>
    <div v-else>
      <ForgotPassword :click-handler="showForgetPassword"></ForgotPassword>
    </div>
  </div>
</template>

<script>
import Close from "../UI/Close";
import Social from "../Icons/Social";
import ForgotPassword from "./ForgotPassword";
import SocialLogin from "./SocialLogin";
import FormulateButton from "../UI/FormulateButton";

export default {
  name: "SignIn",

  components: {
    FormulateButton,
    SocialLogin,
    Close,
    Social,
    ForgotPassword
  },

  props: ["clickHandler"],

  mounted() {
    this.$setState("step_header", false);
    if (localStorage.getItem("signup")) {
      localStorage.removeItem("signup");
    }
  },

  data: function() {
    return {
      values: {
        login: "",
        password: "",
        rememberMe: false
      },
      signError: false
    };
  },
  computed: {
    isCorporation() {
      return (
        this.$getState("corporation")["is"] &&
        this.$getState("corporation")["back_button_color"] != ""
      );
    },
    btnClass() {
      if (this.isFormEnable) {
        return "form-enabled";
      }
    },
    isFormEnable() {
      return this.values.login && this.values.password;
    }
  },

  methods: {
    resetPassword: function() {
      this.$setState("forgotPasswordForm", true);
      this.values = {
        login: "",
        password: "",
        rememberMe: false
      };
      this.signError = false;
    },
    formHandler: function() {
      if (
        this.values.login !== undefined &&
        this.values.login !== "" &&
        this.values.password !== undefined &&
        this.values.password !== ""
      ) {
        this.signError = false;
        this.$http.post("user/signin", this.values).then(res => {
          if (res && res.status !== undefined && res.status) {
            this.$setLocalStorage(
              "thriveAppTokenRemember",
              this.values.rememberMe
            );
            this.$setLocalStorage("thriveAppTokenInitTime", +new Date());
            this.$setLocalStorage("thriveAppToken", res.data.token);
            this.$http.defaults.headers["Authorization"] =
              "Bearer " + res.data.token;
            this.$silentHttp.defaults.headers["Authorization"] =
              "Bearer " + res.data.token;
            this.$token.value = res.data.token;
            let user = res.data.user;
            this.$setState("user", user);
            this.$setState("appUrl", !res.data.app_url ? "" : res.data.app_url);

            this.$setState(
              "fbAppID",
              !res.data.config.fb_app_id ? "" : res.data.config.fb_app_id
            );
            this.$setState(
              "stripeKey",
              !res.data.config.stripe_key ? "" : res.data.config.stripe_key
            );

            if (!!user.id) {
              if (this.$checkUser(user)) {
                this.isInstalled
                  ? this.$router.push("/dashboard")
                  : this.$router.push("/device-selection");
              }
            }
          }

          if (res && res.status !== undefined && !res.status) {
            this.signError = true;
          }
        });
      }
    },
    showForgetPassword() {
      this.$setState("forgotPasswordForm", false);
    }
  }
};
</script>
